import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ContentTabsData} from "../../interfaces/content-tabs-data";

@Component({
  selector: 'brt-content-tabs',
  templateUrl: './content-tabs.component.html',
  styleUrls: ['./content-tabs.component.scss']
})
export class ContentTabsComponent {

  @Output('tabSelected') tabSelected = new EventEmitter<string>();
  @Input('data') set setData(data: ContentTabsData) {
    this.data = data;

    // this.currentActiveTab = data.items[0].id;

    for(let i = 0; i < data.items.length; i++) {
      if(data.items[i].afterNumber !== 0) {
        this.onTabSelected(data.items[i].id);
        break;
      }
    }
  }

  data!: ContentTabsData;

  currentActiveTab = "";

  onTabSelected(id: string) {
    this.currentActiveTab = id;
    this.tabSelected.emit(id);
  }
}
